module.exports = __webpack_public_path__ + "media/images/flags/bm-235f4e7059f14d617f5bb88e733ed622.svg";